import { useState } from 'react';
import { Link } from 'react-router-dom';
import './style.css';
import ArrowRight from '../../img/ui/ui-arrow-top-right.svg';

const Card = ({
  card_title,
  descriptions = [],
  price,
  cta,
  link,
  dropdownItems = [],
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);

  return (
    <div className="card">
      <h2 className="card__title">{card_title}</h2>
      <ul className="card__bullets flow">
        {descriptions.map((desc, idx) => (
          <li key={idx}>{desc}</li>
        ))}
        {price && <li className="price">{price}</li>}
      </ul>

      {dropdownItems.length > 0 ? (
        <div className="dropdown">
          <button onClick={toggleDropdown} className="button">
            {cta}
            <img src={ArrowRight} alt="" aria-hidden="true" width={10} height={11} />
          </button>
          {isDropdownOpen && (
            <ul className="dropdown__menu">
              {dropdownItems.map((item, idx) => (
                <li key={idx}>
                  <Link
                    to={`/package/${item.slug}`}
                    onClick={() => setIsDropdownOpen(false)}
                    className="dropdown__item"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      ) : (
        <Link to={link} className="button">
          {cta}
          <img src={ArrowRight} alt="Arrow" />
        </Link>
      )}
    </div>
  );
};

export default Card;
